<template>
  <transition name="slide-fade">
    <div class="sidebar" v-show="showSidebar">
      <div>
        <ul id="mainnav-menu" class="list-group">
          <template v-for="item in menuGroups">
            <li class="list-header" v-permission="Auth[item.authName]">
              {{ item.name }}
            </li>
            <li
              v-for="child in item.children"
              v-permission="Auth[child.authName]"
              :key="child.module"
              :class="{ 'active-sub': $route.meta.module == child.module }"
            >
              <router-link :to="child.path">
                <!-- <i :class="item.icon"></i> -->
                <span class="menu-title">{{ child.name }}</span>
                <span class="nav-badge" v-if="badges[child.module]">{{
                  badges[child.module]
                }}</span>
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import { menuGroups } from "@/config/navs";
import { navBadgeData } from "../../service/getData";

export default {
  data() {
    return {
      menus: [],
      menuGroups,
      badges: {},
      timer: null
    };
  },
  computed: {
    ...mapGetters(["userInfo", "showSidebar"])
  },
  watch: {
    $route() {
      this.getBadgeCount();
    }
  },
  mounted() {
    let that = this;
    this.timer = setInterval(function() {
      that.getBadgeCount();
    }, 1000 * 60);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  created() {
    this.getBadgeCount();
  },
  methods: {
    async getBadgeCount() {
      let res = await navBadgeData();
      if (res.code == 0) {
        this.badges = res.data;
      }
    }
  }
};
</script>

<style scoped>
.sidebar {
  width: 250px;
  min-width: 250px;
  position: relative;
  overflow-y: auto;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  /* transition: opacity 5s; */
  transition: margin-left 0.2s;
}
.slide-fade-enter, .slide-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  /* opacity: 0; */
  margin-left: -250px;
}

.nav-badge {
  line-height: 1;
  background: #f56c6c;
  border-radius: 10px;
  height: 14px;
  min-width: 14px;
  font-size: 11px;
  margin-left: 5px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
